import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";

export default function Preloader() {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      opacity: [0, 1, 1, 0],
      scale: [0.9, 1.05, 1],
      transition: { duration: 2.5, ease: "easeInOut" },
    });
  }, [controls]);

  return (
    <div
      id="preloader"
      className="fixed inset-0 bg-[#060c1f] z-[10020] flex flex-col items-center justify-center overflow-hidden"
    >
      {/* خلفية ضوء متحرك */}
      <motion.div
        className="absolute w-[400px] h-[400px] rounded-full bg-[radial-gradient(circle,#22ff9b44_0%,transparent_70%)] blur-3xl"
        animate={{
          scale: [1, 1.4, 1],
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
      />

      {/* لوجو متحرك */}
      <motion.div
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ duration: 1.2, ease: "backOut" }}
        className="relative w-[100px] h-[100px] md:w-[130px] md:h-[130px]"
      >
        <motion.img
          src="logo.png"
          alt="Tarek Logo"
          className="w-full drop-shadow-[0_0_25px_#22ff9bcc]"
          animate={{
            rotate: [0, 5, -5, 0],
            scale: [1, 1.05, 1],
          }}
          transition={{
            repeat: Infinity,
            duration: 2.5,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="absolute inset-0 rounded-full bg-[radial-gradient(circle,#22ff9b33_0,#22ff9b11_30%,transparent_60%)]"
          animate={{
            opacity: [0.4, 0.8, 0.4],
            scale: [1, 1.15, 1],
          }}
          transition={{ repeat: Infinity, duration: 2.8, ease: "easeInOut" }}
        />
      </motion.div>

      {/* النص */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 1 }}
        className="text-[#22ff9b] font-extrabold font-poppins text-center mt-5 text-base sm:text-lg tracking-wide drop-shadow-[0_0_10px_#22ff9b66]"
      >
       الهدوء قبل العاصفة... وأنا العاصفة<br className="sm:hidden" /> 
      </motion.div>

      {/* خط تحميل أنيق */}
      <motion.div
        className="mt-6 w-40 h-[3px] bg-[#22ff9b33] rounded-full overflow-hidden"
      >
        <motion.div
          className="h-full bg-[#22ff9b] rounded-full"
          initial={{ width: "0%" }}
          animate={{ width: ["0%", "100%"] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />
      </motion.div>
    </div>
  );
}
